import React from 'react';
import { Navigate } from 'react-router-dom';

export default function PublicRoute({ children }) {
  const token = sessionStorage.getItem('token');
  // si on a déjà un token => on redirige sur /dashboard
  return token ? <Navigate to="/dashboard" /> : children;
}